import { http } from '../utils/http/index'

export class UserApi {
  // 更新用户信息
  async updateUserInfo(params: any) {
    return http.post('/users/update', params)
  }

  // 获取用户详情
  async getUserDetail(params: any) {
    return http.get('/users/detail', params)
  }
  // 商家权限
  async myRoles(params: any) {
    return http.get('/users/myRoles', params)
  }
}
